import React from 'react';
import StarIcon from '../../HOME/SVG/StarIcon';

const ModeIcon = ({ starMargin = '6px 0 0 6px', color = 'rgb(216, 153, 164)', width = '100%', viewBox = '0 0 100 100' }) => (
  <div style={{ display: 'grid' }}>
    <svg style={{ gridArea: '1/1' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
      <g id="tile" stroke={color} strokeWidth="2" fill="none">
        <rect x="1" y="1" width="98" height="98" fill="rgba(0,0,0, 0.1)" />
        <line x1="50" x2="50" y2="100" />
        <line y1="50" x2="100" y2="50" />
      </g>
      <g stroke={color === 'black' ? 'black' : 'red'} strokeWidth="2">
        <line x1="65" y1="15" x2="85" y2="35" />
        <line x1="85" y1="15" x2="65" y2="35" />
        <line x1="15" y1="65" x2="35" y2="85" />
        <line x1="35" y1="65" x2="15" y2="85" />
        <line x1="65" y1="65" x2="85" y2="85" />
        <line x1="85" y1="65" x2="65" y2="85" />
      </g>
    </svg>
    <span style={{ gridArea: '1/1', margin: starMargin }}>
      <StarIcon width={width / 3} shadow={color === 'black'} color="yellow" color2="orange" />
    </span>
  </div>
);

export default ModeIcon;
